// Keep the source explicit: registration does not establish organization membership.
export function personMembership(person) {
  const sources = [
    ['member_since', 'Membro desde', 'Data de entrada registrada na organização atual.'],
    ['account_access_since', 'Acesso à conta desde', 'Data de criação do vínculo de acesso à conta atual.'],
    ['profile_created_at', 'Cadastro desde', 'Data de cadastro do perfil; a entrada na organização não está registrada.'],
  ]
  for (const [field, label, title] of sources) {
    if (!person?.[field]) continue
    const date = new Date(person[field])
    if (!Number.isFinite(date.getTime())) continue
    return { text: `${label} ${date.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })}`, title }
  }
  return { text: 'Data de entrada não informada', title: 'Nenhuma data de vínculo ou cadastro disponível.' }
}
